"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebAction = void 0;
const extraction_1 = require("./extraction");
const reporting_1 = require("./reporting");
const types_1 = require("./types");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_sentry_1 = require("@snapchat/web-sentry");
const web_env_1 = require("@snapchat/web-env");
const serverReportingEndpointSuffix = "/web-action";
const getUTMValues = () => {
    if ((0, web_env_1.isRunningOnServer)()) {
        return {
            utmCampaign: "",
            utmContent: "",
            utmMedium: "",
            utmSource: "",
            utmTerm: "",
        };
    }
    const uriParams = new URLSearchParams(window.location.search);
    return {
        utmCampaign: uriParams.get("utm_campaign") || "",
        utmContent: uriParams.get("utm_content") || "",
        utmMedium: uriParams.get("utm_medium") || "",
        utmSource: uriParams.get("utm_source") || "",
        utmTerm: uriParams.get("utm_term") || "",
    };
};
function buildWebActionEvent({ pageType, actionName, deepLinkUrl = "", destination = "", actionSource = "", webClientId, }) {
    if (!webClientId) {
        if ((0, web_env_1.isRunningOnDevEnv)()) {
            console.error("Missing params for WebAction event");
        }
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: `BlizzardEvents.WebAction.MissingParams.${types_1.PageType[pageType]}.${actionName}`,
                value: 1,
            });
        }
        (0, web_sentry_1.logSentryError)("Missing params for WebAction Blizzard Event");
        return;
    }
    // [WEB-1672] For detecting rendering failure issues by tracking total number of web action blizzard event per page.
    // If there is a sudden drop in metrics, there is something wrong with how the page is rendering.
    if (graphene_1.default.isReady()) {
        graphene_1.default.increment({
            metricsName: `BlizzardEvents.WebAction.Success.${types_1.PageType[pageType]}.${actionName}`,
            value: 1,
        });
    }
    return {
        webServerEventBase: (0, extraction_1.extractWebServerEventBase)(pageType, webClientId),
        actionName,
        deepLinkUrl,
        destination,
        actionSource,
        ...getUTMValues(),
    };
}
function reportWebAction(params) {
    const webActionEvent = buildWebActionEvent(params);
    if (webActionEvent) {
        (0, reporting_1.reportServerEvent)(serverReportingEndpointSuffix, webActionEvent);
    }
}
exports.reportWebAction = reportWebAction;
//# sourceMappingURL=WebAction.js.map